import React, {FC} from "react";
import {Box, DialogTitle, IconButton, makeStyles} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {px} from "Configs/theme";

interface Props {
  title: string;
  close?: () => void;
}

const ModalTitle: FC<Props> = (props) => {
  const classes = useStyles();

  return (
      <DialogTitle disableTypography className={classes.dialogTitle}>
        {props.title && <h2 className={classes.headline}>{props.title}</h2>}
        {props.children && (
            <Box className={classes.headerContent}>
              {props.children}
            </Box>
        )}
        {props.close && (
            <IconButton className={classes.backButton} onClick={props.close}>
              <CloseIcon htmlColor="#34180E"/>
            </IconButton>
        )}
      </DialogTitle>
  );
};

export default ModalTitle;

const useStyles = makeStyles({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
  },
  backButton: {
    transform: `translate3d(-8px, 0, 0)`,
  },
  headline: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    height: px.xxxl,
    margin: 0,
    marginRight: px.l,
    textTransform: "uppercase",
    fontWeight: 800,
    letterSpacing: 0,
    fontSize: "16px",
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  }
});
